import { isWalletBrowser } from "./isMobile";

export const openNewTab = (url) => {
  isWalletBrowser()
    ? window.location.assign(url)
    : window.open(url);
}
